// extracted by mini-css-extract-plugin
module.exports = {"component":"ButtonRound_component__mAEl9","left":"ButtonRound_left__Feh1G","right":"ButtonRound_right__boTmY"};